<template lang="html">
  <img class="pt-3 mb-4" src="@/assets/logo.svg" alt="logo" width="250" />
  <h1 class="title">
    Would you like to see a competition at the summer party again next year?
  </h1>
  <div class="d-grid gap-2">
    <button
      v-for="answer in answers"
      v-bind:key="answer"
      type="button"
      class="btn btn-lg bg-field"
      :class="[answerChecked(answer) ? 'btn-primary' : 'btn-outline-secondary']"
      @click="selectAnswer(answer)"
    >
      <i class="bi bi-square" v-if="!answerChecked(answer)"></i>
      <i class="bi bi-check-square" v-if="answerChecked(answer)"></i>
      {{ answer }}
    </button>

    <!-- Text input for "Anders" option -->
    <!-- <div v-if="checkedAnswer === 'Anders...'" class="mt-3">
      <input
        type="text"
        class="form-control form-control-lg rounded-0 text-center field"
        placeholder="Geef uw antwoord hier..."
        v-model="customAnswer"
        style="text-align: center"
      />
    </div> -->

    <button
      type="button"
      class="btn btn-primary btn-lg rounded-pill"
      @click="setQuestionThree()"
      :disabled="!isValidAnswer"
    >
      <span>Next</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionThreeScreen",
  data: () => ({
    answers: ["Yes", "No", "No opinion"],
    checkedAnswer: null, // Single answer instead of array
    customAnswer: "", // Store custom text input
  }),
  methods: {
    selectAnswer(answer) {
      // Only one answer can be selected at a time
      if (this.checkedAnswer === answer) {
        this.checkedAnswer = null; // Uncheck the answer if already selected
        this.customAnswer = ""; // Clear custom answer when unchecking
      } else {
        this.checkedAnswer = answer; // Select the new answer
        if (answer !== "Anders...") {
          this.customAnswer = ""; // Clear custom answer for other options
        }
      }
    },
    // Check if the passed answer is selected
    answerChecked(answer) {
      return this.checkedAnswer === answer;
    },
    // Commit the selected answer to the store
    setQuestionThree() {
      // If "Anders" is selected, use the custom answer, otherwise use the selected answer
      const finalAnswer =
        this.checkedAnswer === "Anders..." && this.customAnswer.trim()
          ? this.customAnswer.trim()
          : this.checkedAnswer;

      this.$store.commit("setQuestionThree", finalAnswer);
    },
  },
  computed: {
    isValidAnswer() {
      // Check if there's a valid answer selected
      if (!this.checkedAnswer) return false;

      // If "Anders" is selected, require custom text input
      if (this.checkedAnswer === "Anders...") {
        return this.customAnswer.trim().length > 0;
      }

      // For other options, just need a selection
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";
</style>
